import styled from "styled-components";

const Item = styled.li`
  color: #ccc;
  font-size: 12px;
  list-style: none;
`;
export default Item;